import { SectionTitle } from '@/components/SectionTitle';
import { Card } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import type { DashboardTotals } from '@/lib/dashboard-model';
import { formatDurationHm } from '@/lib/format';

const CARDS: Array<{ key: keyof DashboardTotals; label: string }> = [
  { key: 'today', label: 'Today' },
  { key: 'week', label: 'This week' },
  { key: 'month', label: 'This month' },
];

/** Saved entries only (approved decision 2); the caption says so. */
export function SummaryCards({ totals }: { totals: DashboardTotals | undefined }): JSX.Element {
  return (
    <section aria-labelledby="summary-heading" className="mb-8">
      <SectionTitle id="summary-heading" title="Summary" hint="Total time tracked today, this week (Mon–Sun), and this calendar month." />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        {CARDS.map(({ key, label }) => (
          <Card key={key}>
            <p className="mb-1 text-xs text-muted-foreground">{label}</p>
            {totals ? (
              <p className="font-mono text-2xl tabular-nums text-foreground" aria-label={`${label} total`}>
                {formatDurationHm(totals[key])}
              </p>
            ) : (
              <Skeleton className="h-8 w-24" />
            )}
          </Card>
        ))}
      </div>
      <p className="mt-2 text-xs text-muted-foreground">Running timer not included</p>
    </section>
  );
}
